import { useMemo } from 'react';
import sortBy from 'lodash.sortby';
import { createSelector } from '@reduxjs/toolkit';

import { useAppSelector } from 'js/store/hooks';
import { ImageCategory, RootState } from 'js/types';

const librariesSelector = (state: RootState) => state.images.libraries;
const loadingLibrariesSelector = (state: RootState) => state.images.loadingLibraries;
const selector = createSelector([librariesSelector, loadingLibrariesSelector], (libraries, loadingLibraries) => {
  const sortedLibrariesByName = sortBy(libraries, 'editorName');

  return { libraries: sortedLibrariesByName, loadingLibraries };
});

export function useLibraries(): [boolean, ImageCategory[]] {
  const { libraries, loadingLibraries } = useAppSelector(selector);
  const memoizedReturnValue = useMemo((): [boolean, ImageCategory[]] => {
    return [loadingLibraries, libraries];
  }, [loadingLibraries, libraries]);

  return memoizedReturnValue;
}
